/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listTodos} from '../api'

export const useMutationListTodos = createReactQueryMutationHook('listTodos', listTodos)
